import preact from 'preact'
import parser from './DocumentParser'

class TranslationForm extends preact.Component {
  constructor (props) {
    super(props)
    this.state = {
      cssClass: 'live-edit__form'
    }

    this.onPhraseGetStart = this.onPhraseGetStart.bind(this)
    this.onPhraseGetEnd = this.onPhraseGetEnd.bind(this)
    this.onTranslateEnd = this.onTranslateEnd.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }
  // interface for DocumentParser
  onPhraseGetStart () {
    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form loading'
    }))
  }

  onPhraseGetEnd (data) {
    this.setState(Object.assign({
      cssClass: 'live-edit__form active'
    }, data))
    this.textInput.focus()
  }

  onTranslateEnd (data) {
    this.setState(Object.assign({
      cssClass: 'live-edit__form done'
    }, data))
  }

  handleClose () {
    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form'
    }))
  }

  handleSubmit (e) {
    e.preventDefault()

    this.setState(Object.assign(this.state, {
      cssClass: 'live-edit__form sending'
    }))

    parser.translate(this.state)
  }

  handleChange (e) {
    this.setState(Object.assign(this.state, {
      translation: e.target.value
    }))
  }

  handleKeyDown (e) {
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  componentDidMount () {
    if (this.props.liveEdit) {
      parser.init(this.onPhraseGetStart, this.onPhraseGetEnd, this.onTranslateEnd)
      document.addEventListener('keydown', this.handleKeyDown)
    }
  }

  componentWillUnmount () {
    if (this.props.liveEdit) {
      parser.exit()
    }
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  render () {
    const { cssClass, category, message, translation } = this.state

    return <form class={cssClass}>
      <button type='button' onclick={this.handleClose} class='btn--cta btn--close icon--cross' title='Hide panel (<esc>)' />
      <label>
        <strong>Category</strong> <em>{category}</em> - <strong>Phrase</strong> <em>{message}</em>
      </label>
      <div class='live-edit__form__inputs'>
        <input type='text' value={translation} ref={input => { this.textInput = input }} onchange={this.handleChange} />
        <button type='submit' onclick={this.handleSubmit} class='btn--cta' title='Save (<enter>)'>Save</button>
      </div>
    </form>
  }
}

module.exports = options => {
  preact.render(
    <TranslationForm {...options} />, document.querySelector(options.el)
  )
}
